import React, { useEffect, useState } from "react";
import "../assets/css/scroll.css";
import setupIcon from '../assets/img/Icons/setup-icon.png'
import affordableCost from '../assets/img/Icons/affordable-cost.png'
import efficiancy from '../assets/img/Icons/efficiancy.png'
import productivity from '../assets/img/Icons/productivity.png'
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import labill1 from './../assets/img/Illustrations/Laboratory-amico.svg';
// import EastSharpIcon from '@mui/icons-material/EastSharp';

const ScrollingComponent = () => {
  const [scrollPosition, setScrollPosition] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            setScrollPosition(window.scrollY);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

  return (
    <div>
        <div className="prod-heading">SOLUTIONS</div>
        <div className="full-page-scroll-wrapper">
            <div className="scroll-content-main-body">
                <section id="lims" className="sticky-scroll-feature-wrapper section-one">
                    <div className="sticky-scroll-feature-content">
                        <div className="sticky-feature-inner-container">
                            <div className="sticky-feature-text-box" style={{fontFamily:'Outfit, sans-serif'}}>
                                <div className="prod-type">Lab Iconics LIMS</div>
                                <div className="sticky-feature-text">
                                    <div className="title-content">
                                        Lab Iconics LIMS (Laboratory Information Management System) is a digital backbone for the labs to improve quality,  compliance and safety throughout product life cycle.
                                    </div>
                                    <div className="keyicons">
                                        <div className='keyicons-items'>
                                            <div><img src={setupIcon} alt="" className='keyicons-items-img'/></div>
                                            <div>Streamline Your Lab Workflow - Efficiently track samples, manage storage, maintain inventory, and schedule equipment</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={affordableCost} alt="" className='keyicons-items-img' /></div>
                                            <div>Automate & Optimize - Create custom workflows, automate processes, and minimize manual errors</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={efficiancy} alt="" className='keyicons-items-img' /></div>
                                            <div>Enhance Productivity - Boost efficiency while ensuring data accuracy and compliance</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={productivity} alt="" className='keyicons-items-img' /></div>
                                            <div>Ensure Data Integrity - Prevent data loss with secure storage and standardized protocols</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='learn-more-div'>
                                    <Nav.Link as={Link} to='/lims' href='#LIMS' >
                                        <div className='learn-more-btn' style={{backgroundColor:'#bfd6e1'}}>
                                            <span>Explore</span>
                                            <div className="arrow arrow--right">
                                                <span></span>
                                            </div>
                                        </div>
                                    </Nav.Link>
                                </div>
                            </div>
                            <div className="sticky-feature-image-container img-one">
                                <img src={labill1} alt="Content illustration" />
                            </div>
                        </div>
                    </div>
                </section>

                <section id="eln" className="section-two">
                    <div className="overlap-content-section-inner">
                        <div className="sticky-feature-inner-container">
                            <div className="sticky-feature-text-box" style={{fontFamily:'Outfit, sans-serif'}}>
                                <div className="prod-type">Lab Iconics ELN</div>
                                <div className="sticky-feature-text">
                                    <div className="title-content" style={{fontFamily:'Outfit, sans-serif'}}>
                                        Lab Iconics ELN (Electronic Lab Notebook) is a software tool specifically designed for scientists and researchers. It helps in Storing and managing laboratory data, including protocols, results, images, and documents.
                                    </div>
                                    <div className="keyicons">
                                        <div className='keyicons-items'>
                                            <div><img src={setupIcon} alt="" className='keyicons-items-img'/></div>
                                            <div>Streamline Your Lab Workflow - Plan, document, and track experiments effortlessly</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={affordableCost} alt="" className='keyicons-items-img' /></div>
                                            <div>Effortless Data Management - Organize projects, experiments, and lab data in one place</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={efficiancy} alt="" className='keyicons-items-img' /></div>
                                            <div>Secure & Compliant - Ensure data security with robust hosting and regulatory compliance</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={productivity} alt="" className='keyicons-items-img' /></div>
                                            <div>Integrated Inventory Control - Manage samples, reagents, and lab resources with ease</div>
                                        </div>
                                    </div>   
                                </div>
                                <div className='learn-more-div-eln'>
                                    <Nav.Link as={Link} to='/eln' href='#ELN'>
                                        <div className='learn-more-btn' style={{backgroundColor:'#ead2e8'}}>
                                            <span>Explore</span>
                                            <div className="arrow arrow--right">
                                                <span></span>
                                            </div>
                                        </div>
                                    </Nav.Link>
                                </div>
                            </div>
                            <div className="sticky-feature-image-container img-two">
                                <img src={labill1} alt="Content illustration" />
                            </div>
                        </div>
                    </div>
                </section>

                <section id="adbs" className="section-five">
                    <div className="overlap-content-section-inner">
                        <div className="sticky-feature-inner-container">
                            <div className="sticky-feature-text-box" style={{fontFamily:'Outfit, sans-serif'}}>
                                <div className="prod-type">Lab Iconics QMS</div>
                                <div className="sticky-feature-text">
                                    <div className="title-content" style={{fontFamily:'Outfit, sans-serif'}}>
                                        Lab Iconics QMS (Quality Management System) streamlines and automates quality control processes, in compliance with industry standards and regulations, and continuous improvement.
                                    </div>
                                    <div className="keyicons">
                                        <div className='keyicons-items'>
                                            <div><img src={setupIcon} alt="" className='keyicons-items-img'/></div>
                                            <div>Automated Quality Control - Streamlines and automates quality processes while ensuring compliance with industry standards</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={affordableCost} alt="" className='keyicons-items-img' /></div>
                                            <div>Centralized Quality Management - Manages deviations, incidents, changes, audits, risks, corrective actions in one platform</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={efficiancy} alt="" className='keyicons-items-img' /></div>
                                            <div> Enhanced Visibility & Accountability - Improves tracking, reporting, and decision-making with real-time quality data</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={productivity} alt="" className='keyicons-items-img' /></div>
                                            <div>Improved Product & Service Quality -  Boosts customer satisfaction and organizational excellence through continuous improvement</div>
                                        </div>
                                    </div>   
                                </div>
                                <div className='learn-more-div-eln'>
                                    <Nav.Link as={Link} to='/qms' href='#QMS'>
                                        <div className='learn-more-btn' style={{backgroundColor:'#b3e0c3'}}>
                                            <span>Explore</span>
                                            <div className="arrow arrow--right">
                                                <span></span>
                                            </div>
                                        </div>
                                    </Nav.Link>
                                </div>
                            </div>
                            <div className="sticky-feature-image-container img-five">
                                <img src={labill1} alt="Content illustration" />
                            </div>
                        </div>
                    </div>
                </section>

                <section id="qms" className="section-three">
                    <div className="overlap-content-section-inner">
                        <div className="sticky-feature-inner-container">
                            <div className="sticky-feature-text-box" style={{fontFamily:'Outfit, sans-serif'}}>
                                <div className="prod-type">Lab Iconics ADBS</div>
                                <div className="sticky-feature-text">
                                    <div className="title-content" style={{fontFamily:'Outfit, sans-serif'}}>
                                        Lab Iconics ADBS (Automated Data Backup System) is a software solution that automates the process of backing up important data and ensures that data is regularly backed up.
                                    </div>
                                    <div className="keyicons">
                                        <div className='keyicons-items'>
                                            <div><img src={setupIcon} alt="" className='keyicons-items-img'/></div>
                                            <div>Automated Backup System - Ensures critical data is backed up regularly to prevent loss or corruption</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={affordableCost} alt="" className='keyicons-items-img' /></div>
                                            <div>Secure Data Protection -  Provides encryption, compression, and versioning for enhanced data security and integrity</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={efficiancy} alt="" className='keyicons-items-img' /></div>
                                            <div>Disaster Recovery Ready - Allows seamless data restoration to different locations or virtual machines</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={productivity} alt="" className='keyicons-items-img' /></div>
                                            <div>Flexible Scheduling - Automates backups at daily, weekly, or monthly intervals for continuous data protection</div>
                                        </div>
                                    </div>   
                                </div>
                                <div className='learn-more-div-eln'>
                                    <Nav.Link as={Link} to='/adbs' href='#ADBS' >
                                        <div className='learn-more-btn' style={{backgroundColor:'#bcc5c8'}}>
                                            <span>Explore</span>
                                            <div className="arrow arrow--right">
                                                <span></span>
                                            </div>
                                        </div> 
                                    </Nav.Link>
                                </div>
                            </div>
                            <div className="sticky-feature-image-container img-three">
                                <img src={labill1} alt="Content illustration" />
                            </div>
                        </div>
                    </div>
                </section>

                <section id="dms" className="section-four">
                    <div className="overlap-content-section-inner">
                        <div className="sticky-feature-inner-container">
                            <div className="sticky-feature-text-box" style={{fontFamily:'Outfit, sans-serif'}}>
                                <div className="prod-type">Lab Iconics DMS</div>
                                <div className="sticky-feature-text">
                                    <div className="title-content" style={{fontFamily:'Outfit, sans-serif'}}>
                                    Lab Iconics DMS (Document Management System) is a cutting‐edge solution that automates the entire document lifecycle, from creation to archiving, optimizes processes such as review, issuance, retrieval.
                                    </div>
                                    <div className="keyicons">
                                        <div className='keyicons-items'>
                                            <div><img src={setupIcon} alt="" className='keyicons-items-img'/></div>
                                            <div>End-to-End Document Automation — From Creation to Archiving, Fully Automated</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={affordableCost} alt="" className='keyicons-items-img' /></div>
                                            <div>Secure Compliance & Accountability - Offers audit trails, e-signatures, access controls to ensure regulatory compliance, data security</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={efficiancy} alt="" className='keyicons-items-img' /></div>
                                            <div>Streamlined Version Control - Maintains structured versioning, preventing duplication, ensuring accuracy in document management</div> 
                                        </div>
                                        <div className='keyicons-items'>
                                            <div><img src={productivity} alt="" className='keyicons-items-img' /></div>
                                            <div>Enhanced Productivity & Accessibility -  Optimizes document retrieval, collaboration, approval workflows with cloud-based accessibility</div>
                                        </div>
                                    </div>   
                                </div>
                                <div className='learn-more-div-eln'>
                                    <Nav.Link as={Link} to='/dms' href='#DMS'>
                                        <div className='learn-more-btn' style={{backgroundColor:'#efd672'}}>
                                            <span>Explore</span>
                                            <div className="arrow arrow--right">
                                                <span></span>
                                            </div>
                                        </div> 
                                    </Nav.Link>
                                </div>
                            </div>
                            <div className="sticky-feature-image-container img-four">
                                <img src={labill1} alt="Content illustration" />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
  );
};

export default ScrollingComponent;
